export type PredefinedField = 'c_event_name' | 'c_cdp_user_id'

const PREDEFINED_FIELD: PredefinedField[] = ['c_event_name', 'c_cdp_user_id']

export const checkIsPredefinedField = (field: string) => {
  return PREDEFINED_FIELD.includes(field as PredefinedField)
}

export default checkIsPredefinedField
